// src/utils/sqrtUtils.js

export function simplifySqrtLatex(n) {
  const int = parseInt(n);
  if (isNaN(int)) return `\\sqrt{${n}}`;

  let outside = 1;
  let inside = int;

  for (let i = 2; i * i <= inside; i++) {
    while (inside % (i * i) === 0) {
      inside = inside / (i * i);
      outside *= i;
    }
  }

  if (inside === 1) return `${outside}`;
  if (outside === 1) return `\\sqrt{${inside}}`;
  return `${outside}\\sqrt{${inside}}`;
}

export function evaluateSqrtString(str) {
  const match = str.match(/^([0-9]*)\s*\*?\s*√([0-9]+)$/);
  if (!match) return parseFloat(str);

  const multiplier = match[1] ? parseFloat(match[1]) : 1;
  const radicand = parseInt(match[2]);

  return multiplier * Math.sqrt(radicand);
}
